export function UpdateToast({
  visible,
  onUpdate,
  onDismiss,
}: {
  visible: boolean;
  onUpdate: () => void;
  onDismiss: () => void;
}) {
  if (!visible) return null;
  return (
    <div className="toast" role="status">
      <span>Update ready</span>
      <button type="button" className="btn" onClick={onUpdate}>
        Reload
      </button>
      <button type="button" className="btn ghost" onClick={onDismiss}>
        Later
      </button>
    </div>
  );
}
